/** @format */

import { getOfflineData } from "../../utils/offline-services";
import { CF_APPROVAL_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS, SLUG } from "../../../common-utilities/utils/end-points/cf-approval";

// GET /v2/capex-calculator/:cfId/export streams back an .xlsx binary — invokeApi (http-service.js)
// always parses the response as JSON, so it can't be used here. This replicates the same
// Authorization/slug header pattern invokeApi uses, but reads the response as a blob and
// triggers a browser download via a temporary object URL + anchor click, instead of parsing JSON.
//
// Simplification vs. invokeApi: this does not proactively refresh an expired access token first.
// In practice this is only ever called immediately after a successful invokeApi POST /calculate
// call (which would have refreshed the token if needed), so the token here is always fresh.
export const downloadCapexExport = async (cfId) => {
  const tokens = getOfflineData("tokens");
  const token = (tokens && tokens.access && tokens.access.token) || "";

  const response = await fetch(`${CF_APPROVAL_HOSTNAME}${REST_URLS.CAPEX_RESULT}${cfId}/export`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      slug: SLUG,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to export Capex Calculator workbook");
  }

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = `capex-calculator-${cfId}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};
